export default {
    m000001: '请输入您当前使用的6位数字交易密码以验证身份',
    m000002: '请输入交易密码',
    m000003: '忘记交易密码',
    m000004: '请设置交易密码',
    m000005: '交易密码',
    m000006: '确认交易密码',
    m000007: '密码长度为6位',
    m000008: '密码为数字',
    m000009: '两次输入的新密码要一致',
    m000010: '如遇问题，请',
    m000011: '联系客服',
    m000012: '提示：可通过访问我的-安全中心页面，管理您的交易验证方式',
    m000013: '交易密码设置成功',
    m000014: '请输入交易密码',
    m000015: '请输入6位数字交易密码',
    m000016: '请再次输入交易密码',
    m000017: '两次输入的密码不一致',
    m000018: '请输入您开户时提交的身份信息以验证身份',
    m000019: '证件号码',
    m000020: '邮箱',
    m000021: '请输入证件号码',
    m000022: '请输入邮箱',
    m000023: '重置成功!',
    m000024: '在线客服',
    m000025: '提示：请提前安装微信，并登录',
    m000026: '客服热线',
    m000027: '客服邮箱',
    m000028: '关闭',
    m000029: '遇到问题',
    m000030: '忘记登录密码',
    m000031: '联系客服',
    m000032: '修改成功!',
    m000033: '修改交易密码',
    m000034: '重置交易密码',
    m000035: '确定',
    m000036: '去设置',
    m000037: '稍后',
    m000038: '身份地址',
    m000039: '居住地址',
}